import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";
import { ClockAlert } from "lucide-react";

interface SignupEncouragementModalProps {
	isOpen: boolean;
	close: () => void;
}

export function SignupEncouragementModal({
	isOpen,
	close,
}: SignupEncouragementModalProps) {
	const navigate = useNavigate();

	const handleSignUp = () => {
		close();
		navigate("/auth/sign-up");
	};

	const handleSignIn = () => {
		close();
		navigate("/auth/log-in");
	};

	return (
		<Dialog open={isOpen} onOpenChange={close}>
			<DialogContent className="sm:max-w-md max-h-[90vh] overflow-y-auto p-0">
				<div className="flex flex-col">
					<div className="p-6">
						<DialogHeader className="mb-4">
							<div className="flex items-center justify-center gap-2 mb-2">
								<ClockAlert className="size-6 text-primary" />
								<DialogTitle className="text-2xl">
									The magic takes time
								</DialogTitle>
							</div>
							<DialogDescription className="py-4 text-md text-center text-balance">
								Users report deeper focus and better productivity after 5
								minutes of listening. Create a free account to{" "}
								<span className="text-primary font-normal">
									extend your time
								</span>{" "}
								and{" "}
								<span className="text-primary font-normal">
									save your favorites.
								</span>
							</DialogDescription>
						</DialogHeader>

						{/* <div className="space-y-3 mb-6">
							<div className="flex items-start gap-2">
								<Check className="size-6 bg-accent text-primary rounded-full p-1 flex-shrink-0" />
								<p className="text-sm">Longer listening</p>
							</div>
							<div className="flex items-start gap-2">
								<Check className="size-6 bg-accent text-primary rounded-full p-1 flex-shrink-0" />
								<p className="text-sm">3 café tracks to get you started</p>
							</div>
							<div className="flex items-start gap-2">
								<Check className="size-6 bg-accent text-primary rounded-full p-1 flex-shrink-0" />
								<p className="text-sm">2 ambient sound colors</p>
							</div>
							<div className="flex items-start gap-2">
								<Check className="size-6 bg-accent text-primary rounded-full p-1 flex-shrink-0" />
								<p className="text-sm">Save your favorite tracks</p>
							</div>
						</div> */}

						<div className="flex flex-col gap-3 mt-6">
							<Button className="w-full" onClick={handleSignUp}>
								Create Free Account
							</Button>
							<Button
								variant="outline"
								className="w-full"
								onClick={handleSignIn}
							>
								Sign In
							</Button>
							<Button variant="ghost" className="w-full" onClick={close}>
								Keep Exploring
							</Button>
						</div>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
